const mode = "online"; // online || local_bun || local_node || local_all
const domain = window.location.hostname;

const devserver = "https://devserver.mapid.io";
const alphaserver = "https://alphaserver.mapid.io";
const prodserver = "https://server.mapid.io";

const mode_2 = "alpha"; //dev || alpha || prod

let final_server;

if (mode_2 === "dev") {
  final_server = devserver;
} else if (mode_2 === "prod") {
  final_server = prodserver;
} else {
  final_server = alphaserver;
}

if (domain === "localhost") {
  if (mode === "local_bun") {
    module.exports = {
      geoServerBaseUrl: final_server,
      bun_server: "http://localhost:4005",
    };
  } else if (mode === "local_node") {
    module.exports = {
      geoServerBaseUrl: "http://localhost:4004",
      bun_server: final_server,
    };
  } else if (mode === "local_all") {
    module.exports = {
      geoServerBaseUrl: "http://localhost:4004",
      bun_server: "http://localhost:4005",
    };
  } else {
    module.exports = {
      geoServerBaseUrl: final_server,
      bun_server: final_server,
    };
  }
} else {
  module.exports = {
    geoServerBaseUrl: final_server,
    bun_server: final_server,
  };
}
